import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../services/notification.service';
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

import { OfflineDownloadsActionTypes, OfflineScopesLoad, OfflineScopesLoadSuccess, OfflineScopesRelease } from '@completion/actions';
import { State } from '@completion/reducers';
import { getCurrentProject } from '@completion/selectors';
import { OfflineDownloadsService } from '../../services/offline-downloads.service';
import { Project } from '@completion/models';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class OfflineDownloadsEffects {
  constructor(
    private actions$: Actions,
    private service: OfflineDownloadsService,
    private store: Store<State>,
    private toastr: NotificationService,
  ) {}

  loadOfflineDownloads$ = createEffect(() =>
    this.actions$.pipe(
      ofType<OfflineScopesLoad>(OfflineDownloadsActionTypes.OfflineScopesLoad),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.service,
        method: 'getOfflineDownloads',
        serviceArgs: ([_, currentProject]) => [currentProject.id],
        onSuccess: (response) => new OfflineScopesLoadSuccess(response as any),
      }),
    ),
  );

  releaseOfflineDownloads$ = createEffect(() =>
    this.actions$.pipe(
      ofType<OfflineScopesRelease>(OfflineDownloadsActionTypes.OfflineScopesRelease),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.service,
        method: 'releaseOfflineDownloads',
        serviceArgs: ([action, currentProject]) => [currentProject.id, action.pkgId, action.pkgType, action.csaIds],
        onSuccess: () => new OfflineScopesLoad(),
      }),
    ),
  );
}
